// generated on build time, from script >> scripts/build-environment-conf.sh

export const environment = {
  production: true,
  env: 'pro',
  baseUrl: 'https://api.opendata.bcds.net',
  cdnImgBaseUrl: 'https://widget.opendata.bcds.net/assets/img/',
  scraperMock: false,
  notificationsBaseUrl: 'wss://notifications.opendata.bcds.net',
  isWebComponent: false // 👇 Variable para el modo SPA o web-component
};


